<div class="page-container">
  <div class="page-title-section">
    <h1><mat-icon>assignment_ind</mat-icon> Grupos de Usuários</h1>
    <p class="page-subtitle">Gerencie os grupos de usuários e suas permissões</p>
  </div>

  <!-- Filters -->
  <div class="filter-section">
    <div class="filter-header">
      <mat-icon>tune</mat-icon>
      Filtros de Pesquisa
    </div>
    <div class="filter-body">
      <form [formGroup]="filterForm">
        <div class="filter-grid cols-4">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Nome</mat-label>
          <input matInput type="text" formControlName="name" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Empresa</mat-label>
          <mat-select placeholder="Selecione a empresa" formControlName="type">
            <mat-option value="1">Todas</mat-option>
            <mat-option value="2">Michelin</mat-option>
            <mat-option value="3">Montadora (OE)</mat-option>
            <mat-option value="4">Concessionaria (CC)</mat-option>
            <mat-option value="5">Dist. Exclusivo (DE)</mat-option>
          </mat-select>
        </mat-form-field>
        </div>
      </form>
    </div>
    <div class="filter-footer">
      <div class="filter-footer-left">
        <button mat-flat-button color="accent" class="mic-btn-icon-left" (click)="applyFilter()">
          <mat-icon>search</mat-icon><span>Buscar</span>
        </button>
        <button mat-stroked-button color="primary" class="mic-btn-icon-left" (click)="resetFilter()">
          <mat-icon>refresh</mat-icon><span>Limpar</span>
        </button>
      </div>
      <div class="filter-footer-right">
        <button mat-flat-button color="primary" class="mic-btn-icon-left" routerLink="/user-profiles/create">
          <mat-icon>add_circle</mat-icon><span>Cadastrar</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-section">
    <mic-table #table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micCellTemplate="let item; name: 'actionsCell'">
        <div class="flex flex-row gap-2">
          <button mat-icon-button color="primary" (click)="redirectToShow(item)">
            <mat-icon>open_in_new</mat-icon>
          </button>
          <button mat-icon-button color="primary" (click)="redirectToEdit(item)">
            <mat-icon>edit_square</mat-icon>
          </button>
        </div>
      </ng-container>
    </mic-table>
  </div>
</div>
